import { useEffect, useState } from "react";
import { Dropdown, Grid, Popup } from "semantic-ui-react";
import FilterIcon from "../../../assets/commonIcon/FilterIcon";
import { CustomButton } from "../../../components/button/Button";
import { TitleView } from "../../../components/titleView/TitleView";
import {
  supplierDisplayOnlyOptions,
  supplierOrderByOptions,
  SupplierTypeLabel
} from "../../../config/constants";
import { SupplierType } from "../../../config/enums/SupplierType.enum";
import {
  getSupplierFilters,
  resetSupplierFilters,
  saveSupplierFilters
} from "../../../utils/cacheStorage";

const SupplierFilter = ({ refetchWithFilters }: any) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSupplierAsUser, setIsSupplierAsUser] = useState<string>("all");
  const [selectedSupplierTypes, setSelectedSupplierTypes] = useState<string[]>([]);
  const [orderBy, setOrderBy] = useState<string>("createdAtDesc");

  useEffect(() => {
    const { isSupplierAsUser, supplierTypes, orderBy } = getSupplierFilters();
    if (isSupplierAsUser !== "all" || supplierTypes.length || orderBy !== "createdAtDesc") {
      setIsSupplierAsUser(isSupplierAsUser);
      setSelectedSupplierTypes(supplierTypes);
      setOrderBy(orderBy);
    }
  }, []);

  const supplierTypeOptions = Object.entries(SupplierTypeLabel).map(([key, label]) => ({
    key,
    value: SupplierType[key as keyof typeof SupplierType].toString(),
    text: label
  }));

  const resetValue = () => {
    setIsSupplierAsUser("all");
    setSelectedSupplierTypes([]);
    setOrderBy("createdAtDesc");
    resetSupplierFilters();
    refetchWithFilters(undefined, [], "createdAtDesc");
    setIsPopupOpen(false);
  };

  const filterValue = () => {
    saveSupplierFilters(isSupplierAsUser, selectedSupplierTypes, orderBy);

    const isSupplierAsUserValue =
      isSupplierAsUser === "user" ? true : isSupplierAsUser === "notUser" ? false : undefined;
    const supplierTypes = selectedSupplierTypes.map(value => parseInt(value, 10));
    refetchWithFilters(isSupplierAsUserValue, supplierTypes, orderBy);
    setIsPopupOpen(false);
  };

  return (
    <Popup
      open={isPopupOpen}
      on="click"
      onOpen={() => setIsPopupOpen(true)}
      onClose={() => {
        setIsPopupOpen(false);
      }}
      size="large"
      position="bottom left"
      trigger={
        <Grid>
          <CustomButton
            className="filterButton"
            iconWithText
            iconChild={<FilterIcon />}
            buttonOutLine
            theme="green"
            title="Filters"
            iconChildTextCustom="productCustomBase"
          />
        </Grid>
      }
    >
      <Grid className="productFilterMainView">
        <Grid.Column>
          <TitleView title="Filter By" />
          <Grid>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className="productFilterTitle">Order By</p>
              <Dropdown
                placeholder="Select Order"
                fluid
                selection
                options={supplierOrderByOptions}
                value={orderBy}
                onChange={(_, { value }) => setOrderBy(value as string)}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className="productFilterTitle">Display Only</p>
              <Dropdown
                placeholder="Select Display Option"
                fluid
                selection
                options={supplierDisplayOnlyOptions}
                value={isSupplierAsUser}
                onChange={(_, { value }) => setIsSupplierAsUser(value as string)}
              />
            </Grid.Column>
            <Grid.Column computer={8} tablet={8} mobile={16}>
              <p className="productFilterTitle">Supplier Data Type</p>
              <Dropdown
                placeholder="Select Supplier Type"
                fluid
                multiple
                selection
                options={supplierTypeOptions}
                value={selectedSupplierTypes}
                onChange={(_, { value }) => setSelectedSupplierTypes(value as string[])}
              />
            </Grid.Column>
          </Grid>
          <Grid className="pt-0">
            <Grid.Column computer={16} tablet={16} mobile={16} className="productFilterButton">
              <CustomButton
                buttonOutLine
                customBase="productFilterCustomButton"
                theme="green"
                title="Reset"
                onClick={resetValue}
              />
              <CustomButton theme="green" title="Apply" onClick={filterValue} />
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Popup>
  );
};

export default SupplierFilter;
